import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "src/environments/environment";
import { CreateOrEditCapacityModel } from "../../models/tables/create-or-edit-capacity.model";
import { VenueModel } from "../../models/venues/venue.model";
import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
import { DivisionModel } from "../../models/divisions/division.model";


const GMN_VENUE_API = environment.apiURL + '/api/gmn/Venue/';
const MNG_VENUE_API = environment.apiURL + '/api/mng/Venue/';

const CAPACITY_API = environment.apiURL + '/api/gmn/Capacity/'

@Injectable({
  providedIn: 'root'
})

export class VenueService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listvenues() {
    var url = GMN_VENUE_API + "listvenues";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  addvenue(model: VenueModel, file: any) {
    var url = GMN_VENUE_API + "addvenue";
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    formData.append('Address', model.address);
    formData.append('Phone', model.phone);
    formData.append('VenueImageFile', file as string);
    formData.append('Latitude', model.latitude!.toString());
    formData.append('Longitude', model.longitude!.toString());

    if (model.capacityConfig) {
      formData.append('Capacity.IsDefault', 'true');
      formData.append('Capacity.Name', model.name);
      formData.append('Capacity.Description', model.name);

      for (let i = 0; i < model.capacityConfig.capacityGroups.length; i++) {
        formData.append(`Capacity.CapacityGroups[][${i}][name]`, model.capacityConfig.capacityGroups[i].name);
        formData.append(`Capacity.CapacityGroups[][${i}][index]`, model.capacityConfig.capacityGroups[i].index.toString());
        for (let j = 0; j < model.capacityConfig.capacityGroups[i].capacityTables.length; j++) {
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].index`, model.capacityConfig.capacityGroups[i].capacityTables[j].index.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].xPosition`, model.capacityConfig.capacityGroups[i].capacityTables[j].xPosition.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].yPosition`, model.capacityConfig.capacityGroups[i].capacityTables[j].yPosition.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].numberOfPeople`, model.capacityConfig.capacityGroups[i].capacityTables[j].numberOfPeople.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].shape`, model.capacityConfig.capacityGroups[i].capacityTables[j].shape);
        }
      }
    }

    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  deleteCapacity(capacityId: string) {
    let url = CAPACITY_API + 'deletecapacity';
    return this._httpService.httpPost(url, '"' + capacityId + '"')
      .pipe(map(response => {
        return response;
      }));
  }

  getvenuedetails(id: string, roles?: Array<RoleNameEnum>) {
    let url = !roles || roles.includes(RoleNameEnum.PosGeneralManager) ? GMN_VENUE_API : MNG_VENUE_API;
    url += 'getvenuedetails?venueId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updatevenue(model: VenueModel, file: any) {
    var url = GMN_VENUE_API + "updatevenue";
    const formData: FormData = new FormData();
    formData.append('Id', model.id);
    formData.append('Name', model.name);
    formData.append('Address', model.address);
    formData.append('Phone', model.phone);
    formData.append('VenueImageFile', file as string);
    formData.append('Latitude', model.latitude!.toString());
    formData.append('Longitude', model.longitude!.toString());
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  deletevenue(id: string) {
    var url = GMN_VENUE_API + 'deletevenue?venueId=' + id;
    return this._httpService.httpPost(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  listallgmnvenuesforcombo() {
    var url = GMN_VENUE_API + "listvenuesforcombo";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  createcapacity(model: CreateOrEditCapacityModel) {
    var url = CAPACITY_API + "createcapacity";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updateCapacity(model: CreateOrEditCapacityModel) {
    var url = CAPACITY_API + "updatecapacity";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  viewVenueCapacity(venueId: string){
    var url = CAPACITY_API + "viewcapacity?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  listallmngvenuesforcombo() {
    var url = MNG_VENUE_API + "listvenuesforcombo";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  listVenueDivisions(venueId: string) {
    let url = GMN_VENUE_API + 'listsubvenues?venueId=' + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  addVenueDivision(model: DivisionModel) {
    let url = GMN_VENUE_API + 'addsubvenue';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  updateVenueDivision(model: DivisionModel) {
    let url = GMN_VENUE_API + 'updatesubvenue';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteDivision(id: string) {
    let url = GMN_VENUE_API + 'deletesubvenue?subvenueId=' + id;
    return this._httpService.httpPost(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  getMenuItemsForDivision(divisionId: string,selectedDate: any) {
    let url = MNG_VENUE_API + 'getmenuitemsforsubvenue?subVenueId=' + divisionId + '&selectedDate='+selectedDate;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  //#endregion
}
